module.exports = __webpack_public_path__ + "img/back-to-back-c.3dc0b4e6.svg";